
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexy9TJFeqyhKDLN2CxkPKoxH8XBZBQxb6_45j7UT3aoxce8Meta } from "/home/vsts/work/1/source/frontend/pages/index.vue?macro=true";
import { default as indexczGIzy5I4d90sTyB8wTppdyQ7UIjXTGrK2uDU7F8JrIMeta } from "/home/vsts/work/1/source/frontend/pages/topics/index.vue?macro=true";
import { default as indexBVMJERmp_45FFGaMc_JK8ofY_bGwYgCrC0rwT3a2tyWjUMeta } from "/home/vsts/work/1/source/frontend/pages/landing/index.vue?macro=true";
import { default as indexZu6Wex9C3abhRd3YLEhF9YeZ6LiGR1RQfbkr7wXtVuoMeta } from "/home/vsts/work/1/source/frontend/pages/scoring/index.vue?macro=true";
import { default as indexJ8I7Vxmv0QNqIvqJF1BB4prgWW1TZwcoiFN09tPz07gMeta } from "/home/vsts/work/1/source/frontend/pages/overview/index.vue?macro=true";
import { default as indexbecwx5IGXAIRbXbh4pw8wI60FNIEjfHBZt_dSVfwdqcMeta } from "/home/vsts/work/1/source/frontend/pages/playback/index.vue?macro=true";
import { default as index01ohRncxwAd_45XXqPnwqVWJkzOMzW3AD2pofnsZ44hTAMeta } from "/home/vsts/work/1/source/frontend/pages/pdfExport/index.vue?macro=true";
import { default as indexs5y4t7lyaXcUDEfPLn1ZUStXQu2dYJuQKjvY_4583NeBIMeta } from "/home/vsts/work/1/source/frontend/pages/sentiment/index.vue?macro=true";
import { default as indexc8YtmsThR9ULJHHxCJUzWfRIyhR7OyOOzdgyM8jePBsMeta } from "/home/vsts/work/1/source/frontend/pages/objections/index.vue?macro=true";
import { default as indexDSlq7e9XW0W84D62WcG5O_452y3AeC2jZoljK0Pv_45uqvEMeta } from "/home/vsts/work/1/source/frontend/pages/maintenance/index.vue?macro=true";
import { default as indexuitPC6PPlH6CMQ9xRwc5QO0row62_45WMgiZPlTRTW5hIMeta } from "/home/vsts/work/1/source/frontend/pages/performance/index.vue?macro=true";
import { default as index6kz4ktPpmQE2C9QEBEYx8Rpz_RdpBzAI5oI5_dD5KpUMeta } from "/home/vsts/work/1/source/frontend/pages/interactions/index.vue?macro=true";
import { default as indexsCo2AKyvfWtwLYjRvRH_TMIfeJGm1GlgqkJTvTzZFq0Meta } from "/home/vsts/work/1/source/frontend/pages/prompt-studio/index.vue?macro=true";
import { default as indexavrgQ0WDf8IktNgqgcsWMmBXcoqWBbjR3nqPZhxeNNYMeta } from "/home/vsts/work/1/source/frontend/pages/interaction/[id]/index.vue?macro=true";
import { default as indexvn7HLYqF1bJ4_45u7b7Fnu_45P02nBIcynie9HGdCwhLbUQMeta } from "/home/vsts/work/1/source/frontend/pages/scoring/scorecards/results/[id]/index.vue?macro=true";
import { default as index45qAHUw9QRGd91WNSuSQFxosCjQwofj9T8zsk0aZPnAMeta } from "/home/vsts/work/1/source/frontend/pages/scoring/schedules/designer/[[id]]/index.vue?macro=true";
import { default as indexxl5an3p82sIdxCO93ApOUebbu5eUSnssPTl86pW2qcAMeta } from "/home/vsts/work/1/source/frontend/pages/scoring/scorecards/designer/[[id]]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexy9TJFeqyhKDLN2CxkPKoxH8XBZBQxb6_45j7UT3aoxce8Meta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/index.vue")
  },
  {
    name: "topics",
    path: "/topics",
    meta: { ...(indexczGIzy5I4d90sTyB8wTppdyQ7UIjXTGrK2uDU7F8JrIMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/topics/index.vue")
  },
  {
    name: "landing",
    path: "/landing",
    meta: { ...(indexBVMJERmp_45FFGaMc_JK8ofY_bGwYgCrC0rwT3a2tyWjUMeta || {}), ...{"middleware":["page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/landing/index.vue")
  },
  {
    name: "scoring",
    path: "/scoring",
    meta: { ...(indexZu6Wex9C3abhRd3YLEhF9YeZ6LiGR1RQfbkr7wXtVuoMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/scoring/index.vue")
  },
  {
    name: "overview",
    path: "/overview",
    meta: { ...(indexJ8I7Vxmv0QNqIvqJF1BB4prgWW1TZwcoiFN09tPz07gMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/overview/index.vue")
  },
  {
    name: "playback",
    path: "/playback",
    meta: { ...(indexbecwx5IGXAIRbXbh4pw8wI60FNIEjfHBZt_dSVfwdqcMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/playback/index.vue")
  },
  {
    name: "pdfExport",
    path: "/pdfExport",
    meta: { ...(index01ohRncxwAd_45XXqPnwqVWJkzOMzW3AD2pofnsZ44hTAMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/pdfExport/index.vue")
  },
  {
    name: "sentiment",
    path: "/sentiment",
    meta: { ...(indexs5y4t7lyaXcUDEfPLn1ZUStXQu2dYJuQKjvY_4583NeBIMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/sentiment/index.vue")
  },
  {
    name: "objections",
    path: "/objections",
    meta: { ...(indexc8YtmsThR9ULJHHxCJUzWfRIyhR7OyOOzdgyM8jePBsMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/objections/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: { ...(indexDSlq7e9XW0W84D62WcG5O_452y3AeC2jZoljK0Pv_45uqvEMeta || {}), ...{"middleware":["page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/maintenance/index.vue")
  },
  {
    name: "performance",
    path: "/performance",
    meta: { ...(indexuitPC6PPlH6CMQ9xRwc5QO0row62_45WMgiZPlTRTW5hIMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/performance/index.vue")
  },
  {
    name: "interactions",
    path: "/interactions",
    meta: { ...(index6kz4ktPpmQE2C9QEBEYx8Rpz_RdpBzAI5oI5_dD5KpUMeta || {}), ...{"middleware":["auth","shared-link","analytics-job","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/interactions/index.vue")
  },
  {
    name: "prompt-studio",
    path: "/prompt-studio",
    meta: { ...(indexsCo2AKyvfWtwLYjRvRH_TMIfeJGm1GlgqkJTvTzZFq0Meta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/prompt-studio/index.vue")
  },
  {
    name: "interaction-id",
    path: "/interaction/:id()",
    meta: { ...(indexavrgQ0WDf8IktNgqgcsWMmBXcoqWBbjR3nqPZhxeNNYMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/interaction/[id]/index.vue")
  },
  {
    name: "scoring-scorecards-results-id",
    path: "/scoring/scorecards/results/:id()",
    meta: { ...(indexvn7HLYqF1bJ4_45u7b7Fnu_45P02nBIcynie9HGdCwhLbUQMeta || {}), ...{"middleware":["auth","shared-link","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/scoring/scorecards/results/[id]/index.vue")
  },
  {
    name: "scoring-schedules-designer-id",
    path: "/scoring/schedules/designer/:id?",
    meta: { ...(index45qAHUw9QRGd91WNSuSQFxosCjQwofj9T8zsk0aZPnAMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/scoring/schedules/designer/[[id]]/index.vue")
  },
  {
    name: "scoring-scorecards-designer-id",
    path: "/scoring/scorecards/designer/:id?",
    meta: { ...(indexxl5an3p82sIdxCO93ApOUebbu5eUSnssPTl86pW2qcAMeta || {}), ...{"middleware":["auth","page-view-tracking"]} },
    component: () => import("/home/vsts/work/1/source/frontend/pages/scoring/scorecards/designer/[[id]]/index.vue")
  }
]